import React from 'react'
import { ArticlePublication } from '@news-mono/web-common'
import { InlinePositionedContent } from '../Publication.props'
import InlineTaboolaAmp from '../../../advertising/Taboola/InlineTaboola/InlineTaboola.amp'
import {
    InlineContentTypes,
    InlineTaboolaAmpComponent,
} from '../SharedPublication.routing'

export interface GetInlinePositionedTaboolaAmpProps {
    publication: ArticlePublication
    inlinePublicationContent: InlineContentTypes[]
}

export function isTaboolaAmpComponent(
    content: InlineContentTypes,
): content is InlineTaboolaAmpComponent {
    return content.kind === 'inline-taboola-amp'
}

export const getInlinePositionedTaboolaAmp = (
    props: GetInlinePositionedTaboolaAmpProps,
): InlinePositionedContent[] => {
    const { publication, inlinePublicationContent } = props

    if (publication.kind !== 'article') {
        return []
    }

    /** Don't insert if there are less than 8 content blocks in the story */
    if (publication.content.length <= 8) {
        return []
    }

    return inlinePublicationContent
        .filter(isTaboolaAmpComponent)
        .map((content) => {
            const mappedContent = {
                position: content.insertAfter,
                element: <InlineTaboolaAmp />,
            }
            return mappedContent
        })
}
